/**
 * TanStack Query Status Constants
 */
export const QUERY_STATUSES = {
  PENDING: 'pending',
  ERROR: 'error',
  SUCCESS: 'success',
  IDLE: 'idle' // Although we don't explicitly check for idle currently
}
